import { render, staticRenderFns } from "./attendance.vue?vue&type=template&id=1076f5b3&"
import script from "./attendance.vue?vue&type=script&lang=js&"
export * from "./attendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports